import { Flex } from "antd";
import React from "react";

// Assest
import confirm from "../../../assets/images/confirm-icon.svg";
import { CustomParagraph, CustomTitle } from "../../../components";

const ThankYou = () => {
  return (
    <div className="thank-you">
      <Flex vertical align="middle" justify="center">
        <img src={confirm} alt="" className="confirm-icon" />
        <CustomTitle
          text="Thank you for your interest!"
          fontSize="24px"
          fontWeight="900"
          lineHeight="32px"
          marginTop="24px"
          marginBottom="8px"
          textAlign="center"
        />
        <CustomParagraph
          text="We appreciate your interest in ZoomLogi. A ZoomLogi representative will reach back out soon to discuss next steps."
          fontSize="14px"
          fontWeight="400"
          lineHeight="20px"
          textAlign="center"
        />
      </Flex>
    </div>
  );
};

export default ThankYou;
